var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content", style: _vm.mainContentViewHeight },
    [
      _c(
        "div",
        { style: { height: _vm.tableMaxHeight + "px", overflow: "hidden" } },
        [
          _c("iframe", {
            staticStyle: { "margin-top": "-56px" },
            attrs: {
              src: _vm.iframeUrl,
              id: "history2DArea",
              width: "100%",
              height: _vm.tableMaxHeight + 55,
              frameborder: "0",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }